import { render } from "./SkeletonBaseLayout.vue?vue&type=template&id=7cf1cc48&scoped=true"
import script from "./SkeletonBaseLayout.vue?vue&type=script&lang=js"
export * from "./SkeletonBaseLayout.vue?vue&type=script&lang=js"

import "./SkeletonBaseLayout.vue?vue&type=style&index=0&id=7cf1cc48&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7cf1cc48"
/* hot reload */
if (module.hot) {
  script.__hmrId = "7cf1cc48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7cf1cc48', script)) {
    api.reload('7cf1cc48', script)
  }
  
  module.hot.accept("./SkeletonBaseLayout.vue?vue&type=template&id=7cf1cc48&scoped=true", () => {
    api.rerender('7cf1cc48', render)
  })

}

script.__file = "src/ui/skeleton/SkeletonBaseLayout.vue"

export default script